import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardTitle,
  Alert,
  CardBody,
  Button,
  Modal,
  ModalBody
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'
import { post, get, put } from "../../helpers/api_helper";
import Loader from "../../components/Loader";
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";

const Patient = props => {
  const { user, company } = props;
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [mobile, setMobile] = useState("");
  const [currentView, setCurrentView] = useState(null);
  const [isView, setIsView] = useState(false);

  useEffect(() => {
    setColumns([
      {
        name: 'Mobile',
        selector: row => row.mobile,
      },
      {
        name: 'Bookings',
        selector: row => row.count,
      },
      {
        name: 'Recent Booking',
        selector: row => row.createdAt,
      },
      {
        name: 'Address',
        selector: row => row.address,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleView(row)}
            title={"View"}
            style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-eye" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ]);
  }, []);

  useEffect(() => {
    if (user) {
      setCurrentPage(1);
      getUsers(1, perPage, mobile);
    }
  }, [user, mobile]);

  const getUsers = (page = currentPage, limit = perPage, searchMobile = mobile) => {
    setTableLoading(true);
    let body = { token: user?.token, page, limit };
    if (searchMobile != "")
      body = { ...body, mobile: searchMobile };

    post("/user/list", body)
      .then(json => {
        console.log('response from get user list', json);
        setTableLoading(false);
        setLoading(false);
        if (json?.statusCode == 200) {
          const rows = (json?.data || []).map((item) => ({
            ...item,
            name: [...new Set((item?.name || []).map(n => n))]
          }));

          if (typeof json?.total === "number") {
            setData(rows);
            setTotalRows(json.total);
          } else {
            setTotalRows(rows.length);
            const startIndex = (page - 1) * limit;
            setData(rows.slice(startIndex, startIndex + limit));
          }
        }
      })
      .catch(error => {
        setTableLoading(false);
        setLoading(false);
        console.log('error while getting user list', error);
      })
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getUsers(page, perPage, mobile);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    getUsers(page, newPerPage, mobile);
  };

  const handleMobileChange = (tel) => {
    console.log('handling mobile change', tel);
    setMobile(tel);
  }

  const handleView = (item) => {
    console.log('item to view', item);
    setCurrentView(item);
    setIsView(true);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Patient Data" />
        <Row>
          <Row>
            <Col>
              <AvForm
                className="form-horizontal"
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="form-group mb-4">
                    <AvField
                      name="mobile"
                      label={"Mobile Number"}
                      // value={data?.mobile}
                      className="form-control"
                      placeholder={`Enter Mobile e.i (9876543210)`}
                      type="number"
                      onChange={(e) => handleMobileChange(e.target.value)}
                    />
                  </div>
                </div>
              </AvForm>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <DataTable
                columns={columns}
                data={data}
                progressPending={tableLoading}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                customStyles={{
                  headCells: {
                    style: {
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: 15
                    },
                  }
                }}
              />
            </CardBody>
          </Card>
        </Row>
        {isView &&
          <Modal isOpen={isView} toggle={() => setIsView(false)} centered={true}>
            <ModalBody className="py-3 px-5">
              <div className='d-flex justify-content-between align-items-center'>
                <CardTitle style={{ fontWeight: 'bold', color: 'black' }}>Booked For</CardTitle>
                <Button type="button" style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }} onClick={() => setIsView(false)}>Close</Button>
              </div>
              {currentView?.name?.map((item, idx) => {
                return (
                  <div key={idx} style={{marginTop:20}}>
                    <h4 style={{ color: 'black' }}>{item}</h4>
                    <hr style={{width:'100%', height:1, backgroundColor:'gray'}}></hr>
                  </div>
                )
              })}
            </ModalBody>
          </Modal>
        }
      </div>
    </React.Fragment>
  )
}

Patient.propTypes = {
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  return { user }
}

export default withRouter(
  connect(mapStatetoProps, {})(Patient)
)
